export const RPPS_GET = 'RPPS_GET';
export const RPP_ADD = 'RPP_ADD';
export const RPP_GET = 'RPP_GET';
export const RPP_EDIT = 'RPP_EDIT';
export const RPP_UPLOADFILE = 'RPP_UPLOADFILE';
export const RPP_DELETE = 'RPP_DELETE';
export const RPP_RESET_SEARCH = 'RPP_RESET_SEARCH';
